import { useToken } from "@chakra-ui/react";

const useColors = (tokens: string[]) => {
  return useToken("colors", tokens);
};

export default useColors;
